import Popover from "components/Popover";
import StudyTypeTooltip from "components/Popover/StudyTypeTooltip/StudyTypeTooltip";
import { IN_VITRO_STUDY_URL } from "constants/config";
import useLabels from "hooks/useLabels";
import { useAppSelector } from "hooks/useStore";
import Tag from "../Tag";
import { InVitroTrialIcon } from "design_system";

interface InVitroStudyTagProps {
  pressable?: boolean;
  isCompact?: boolean;
}

function InVitroStudyTag(props?: InVitroStudyTagProps) {
  const [pageLabels] = useLabels("tooltips.in-vitro-trial");
  const isMobile = useAppSelector((state) => state.setting.isMobile);

  return (
    <Popover
      interactive
      maxWidth={306}
      appendToParent
      tooltipContent={
        <StudyTypeTooltip
          title={pageLabels.title}
          content={pageLabels.content}
          icon={<InVitroTrialIcon size="lg" />}
          iconPyramid="bottom"
          learnMoreLink={IN_VITRO_STUDY_URL}
        />
      }
    >
      {props?.isCompact ? (
        <div className="p-1">
          <InVitroTrialIcon size="sm" />
        </div>
      ) : (
        <Tag
          label={pageLabels["tag"]}
          icon={<InVitroTrialIcon size="sm" />}
          data-testid="in-vitro-trial-tag"
          onClick={(e) => {
            if (!props?.pressable) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        />
      )}
    </Popover>
  );
}

export default InVitroStudyTag;
